import React, { useState } from 'react';

const PriceRangeSlider = ({
  value = [0, 10000],
  onChange,
  max = 10000,
  currency = "MYR",
}) => {
  const [minthumb, setMinThumb] = useState(0);
  const [maxthumb, setMaxThumb] = useState(0);

  const onChangeMinValue = (e) => {
    const newMinPrice = Math.min(Number(e.target.value), Number(value[1]) - 1);
    onChange([newMinPrice, value[1]]);
    setMinThumb((newMinPrice / max) * 100);
  }

  const onChangeMaxValue = (e) => {
    const newMaxPrice = Math.max(Number(e.target.value), Number(value[0]) + 1);
    onChange([value[0], newMaxPrice])
    setMaxThumb(100 - ((newMaxPrice / max) * 100));
  }

  return (
    <div className="flex flex-col w-full justify-center items-center">
      <div className="flex w-full justify-center items-center relative">
        <input
          type="range"
          min={0}
          max={max}
          value={value[0]}
          onChange={onChangeMinValue}
          className="thumb thumb--left"
          style={{ zIndex: value[0] > max - 100 && "5" }}
        />
        <input
          type="range"
          min={0}
          max={max}
          onChange={onChangeMaxValue}
          value={value[1]}
          className="thumb thumb--right"
        />
        <div className="absolute bg-gray-200 w-full h-[2px]"></div>
        <div
          className="absolute bg-primary z-20 h-[2px] rounded"
          style={{ right: `${maxthumb}%`, left: `${minthumb}%` }}
        />
      </div>
      <div className="w-full flex items-center justify-between pt-5 space-x-4 text-sm text-gray-700">
        <div className="relative">
          <span className="absolute left-[24px] top-[16px] font-medium text-gray-400">{currency}</span>
          <input
            type="text"
            maxLength="5"
            onChange={onChangeMinValue}
            value={value[0]}
            className="w-full h-[50px] px-[24px] py-4 text-right border border-[#CCCCCC] rounded-[31px] bg-white focus:outline-none"
          />
        </div>
        <div><span>-</span></div>
        <div className="relative">
          <span className="absolute left-[24px] top-[16px] font-medium text-gray-400">{currency}</span>
          <input
            type="text"
            maxLength="5"
            onChange={onChangeMaxValue}
            value={value[1]}
            className="w-full h-[50px] px-[24px] py-4 text-right border border-[#CCCCCC] rounded-[31px] bg-white focus:outline-none"
          />
        </div>
      </div>
    </div>
  );
};

export default PriceRangeSlider;